<template>
  <v-card elevation="0" class="ma-2">
    <v-card-title>
      {{ user }}
    </v-card-title>
    <v-card-subtitle>
      {{ server }}
    </v-card-subtitle>
    <v-card-text>
      <v-text-field
        :type="show ? 'text' : 'password'"
        label="Пароль"
        :readonly="SHDataOk"
        @click:append="show = !show"
        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
        class="customtxtField"
        :value="password"
        @input="(e) => updatePassword(e)"
      />
    </v-card-text>
    <v-card-actions>
      <v-btn
        elevation="0"
        :disabled="SHDataOk"
        color="secondary"
        @click="checkServerStatus"
        block
        outlined
      >
        <v-icon> mdi-connection </v-icon>
        Проверить соединение и получить данные</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    show: false,
  }),
  computed: {
    ...mapGetters(["selected", "serverStatus", "SHDataOk", "password"]),
    server() {
      if (this.selected != null) {
        return `[${this.selected.host}] ${this.selected.name}`;
      }
      return "Сервер не выбран";
    },
    user() {
      if (this.selected != null) {
        return `Пользователь: ${this.selected.username}`;
      }
      return "";
    },
  },
  methods: {
    ...mapActions([
      "checkServer",
      "getSHData",
      "updatePassword",
      "resetConnection",
      "clearSHData",
    ]),
    async checkServerStatus() {
      this.$emit("loading-start", "Проверка подключения и прав");
      this.isLoading = true;
      await this.checkServer();
      if (this.serverStatus == 2) {
        await this.getSHData();
        if (this.SHDataOk) {
          this.$emit("cant-continue", false);
        }
      }
      this.isLoading = false;
      this.$emit("loading-stop");
    },
  },
  mounted() {
    this.resetConnection();
    this.clearSHData();
    this.$emit("cant-continue", true);
  },
};
</script>

<style scoped>
:deep() .v-text-field.customtxtField {
  width: 400px;
}
</style>